<template lang="pug">
  .page
    section.head
      .bg.h-100.w-100(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/hero_consulting.webp)'}")
    section.section-dark.bg-black
      b-container.text-left.p-md-5
        h1 Consulting & Curation
        h2 Your End-to-End Fine Art Partner
        p
          | Whether you're curating a private gallery or building a large-scale collection for a 200-room hotel,
          | the process shouldn't be fragmented across multiple vendors and endless coordination calls.
          | We provide a complete, end-to-end solution - combining curatorial expertise, procurement intelligence,
          | and meticulous project management.
    section#sectionServices
      b-container
        h3 OUR SERVICES
        .row.pt-0
          .col-md-5
            h4 Art Consulting & Curation
            p.text-accent.small Art is the defining layer of designing remarkable spaces.
            p We listen first. Your aesthetic vision, project parameters, client preferences, and timeline constraints all shape our curatorial approach. Then we get to work.
            a.ul.text-muted(v-b-toggle.collapse-1="") What this includes
            b-collapse#collapse-1.text-muted
              ul
                li In-depth consultation to understand project vision and requirements
                li Custom curation tailored to your aesthetic, space, and budget
                li Artist research and vetting for commission-based projects
                li Style and trend guidance informed by current market insights
            hr.d-md-none.my-5
          .col-0.service-col.mt-5.mx-3
          .col-md-5
            h4 Procurement & Sourcing
            p.text-accent.small Access to the right pieces, at the right price, without the runaround.
            p We handle the complexity of art acquisition so you don't have to chase down galleries, negotiate terms, or wonder if you're getting fair pricing. Our established relationships with artists, combined with transparent pricing, mean you get competitive rates and priority access to works that aren't widely available.
            a.ul.text-muted(v-b-toggle.collapse-2="") What this includes
            b-collapse#collapse-2.text-muted
              ul
                li Sourcing from our curated collection and extended network
                li Negotiation and acquisition on your behalf
                li Flexible purchase, rental, and commission options
            hr.d-md-none.my-5
          .col-md-5
            h4 Project Management
            p.text-accent.small Complex projects, flawlessly orchestrated.
            p Managing art across multiple locations, or phases requires precision. We become your dedicated art project manager, tracking every piece from specification through installation. We coordinate timelines, keeping all stakeholders informed. One point of contact, complete accountability.
            a.ul.text-muted(v-b-toggle.collapse-3="") What this includes
            b-collapse#collapse-3.text-muted
              ul
                li Centralized tracking of all pieces, timelines, and approvals
                li Collaboration with installers and framers
                li Professional art handling services
            hr.d-md-none.my-5
          .col-0.service-col.mx-3
          .col-md-5
            h4 Proposals & Presentations
            p.text-accent.small Making your vision tangible.
            p Clients need to see it to believe it. We create professional, compelling presentations that bring your art selections to life - from detailed proposals with artist bios and pricing to custom mockups in actual project photography. Every presentation is designed to inspire confidence and facilitate approvals.
            a.ul.text-muted.mt-auto(v-b-toggle.collapse-4="") What this includes
            b-collapse#collapse-4.text-muted
              ul
                li Professional proposal documents with specifications and pricing
                li Custom mockups using your project photography
                li Branded presentation modes for client meetings
    section#sectionTestimonial.section-dark.text-left
      .bg(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/consulting_banner_testimonial.webp)'}")
      b-container.py-5
        .row
          .col-md-6
            i.fa.fa-circle.mb-3.text-white
            p.text-white “Wall Collective’s sensitivity lies in curating selections that feel deeply personal yet remains effortlessly on brief — a rare balance that truly sets them apart..”
            span.small.mt-3.text-white Madre Meyer
            span.small.strong.text-white Creative Director Ampersand Creative
    section#SectionWork.section-alt
      b-container
        h1.mb-5 How We Work Together
      b-container.pl-0.ml-0
        .row.mb-3
          .col-4.picture(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/how_we_work_1.webp)'}")
          .col-8.col-md-6.px-md-5
            span.small.strong 01
            h4 Initial Consultation
            p We start by understanding your project scope, aesthetic direction, budget parameters, and timeline. This can be a 30-minute call or an in-depth onsite meeting.
            .story-line
        .row.mb-3
          .col-4.picture(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/how_we_work_2.webp)'}")
          .col-8.col-md-6.px-md-5
            span.small.strong 02
            h4 Curated Presentation
            p Based on your brief, we present tailored selections with artist information, pricing, availability, and lead times. Everything is organized on our platform for easy review and sharing.
            .story-line
        .row.mb-3
          .col-4.picture(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/how_we_work_3.webp)'}")
          .col-8.col-md-6.px-md-5
            span.small.strong 03
            h4 Approvals and Refinement
            p Your feedback shapes the next round. We iterate until the selection feels exactly right, managing client approvals and revisions along the way.
            .story-line
        .row.mb-3
          .col-4.picture(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/how_we_work_4.webp)'}")
          .col-8.col-md-6.px-md-5
            span.small.strong 04
            h4 Procurement & Production
            p Once approved, we handle acquisition, commission management, framing, and all procurement details. You receive regular updates on production and shipping timelines.
            .story-line
        .row.mb-3
          .col-4.picture(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/how_we_work_5.webp)'}")
          .col-8.col-md-6.px-md-5
            span.small.strong 05
            h4 Logistics & Installation
            p We coordinate delivery, manage installation teams, and ensure every piece is perfectly positioned. You're informed at every step, but never burdened with details.
            .story-line
        .row.mb-3
          .col-4.picture(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/how_we_work_6.webp)'}")
          .col-8.col-md-6.px-md-5
            span.small.strong 06
            h4 Ongoing Partnership
            p After installation, we remain available for valuations, collection advisory, and future projects. Consider us your long-term art partner.
            .story-line.last-man
    section.section-dark.bg-accent
        .container
          .row
            .col-md-6.pb-4
              h1.text-white Let's Discuss Your Project
              p.text-white Whether you're at the early concept stage or need immediate sourcing for an active project, we're ready to help. Schedule a consultation to explore how our end-to-end service can elevate your next project.
              b-button.btn-glass-light(:to="{name: 'contact'}") Schedule a Consultation
            .col-md-6
              img.w-100(src="https://cdn.wallcollective.co/resources/images/consulting_project.webp")
</template>

<script>
import standardMix from '@/mixins/standardMix';
// import { apiService } from '@/services';
// import Vue from 'vue';
// import router from '@/router';

export default {
  metaInfo() {
    return { title: 'Wall Collective corporate art rental' };
  },
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>

  .picture {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    // min-height: 250px;
  }
.story-line {
  border-left: 1px solid black;
  height: 100px !important;
  &.last-man {
    border-color: transparent;
  }
}
.head {
  background-color: black;
  z-index: 0;
  position: relative;
  height: 80vh;
  overflow: hidden;
  .bg {
    // background-attachment: fixed;
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
    background-size: cover;
    background-position: center;
    // @include desktop {
    // background-image: url("@/assets/images/backgrounds/art1.jpg");
    // }
  }
}
.bg {
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: .7;
      z-index: -1;
    }
#sectionTestimonial {
  background-color: black;
  z-index: 0;
  position: relative;
  background-attachment: fixed;
  background-size: cover;
  background-position: bottom;
}
  .inst-tile {
    height: 100px;
  }
  .piece {
      transition: all ease-in 0.5s;
      margin: 15px;
      opacity: 1;
      .thumbnail {
        width: 100%;
      }
  }
  #sectionServices {
    hr {
      background-color: darkgreen;
    }

    .col-md-6 {
      // border-bottom: 2px solid darkgr;
    }
    .service-col {
      border-left: 1px solid green;
      width: 5px !important;
      padding: 0;
      @media (max-width: 580px) {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Consulting.vue